import { isServer } from './server';

declare global {
  interface Window {
    FS?: any;
  }
}

export const isFullStoryLoaded = () => {
  return !isServer() && window.FS;
};
